
import { Dispatch, SetStateAction } from 'react';
import MyModal from '../../../../components/Modal';

export default function RemoveFileModal({
  removeFileModalShow,
  setRemoveFileModalShow,
  removeFile,
}: {
  removeFileModalShow: boolean;
  setRemoveFileModalShow: Dispatch<SetStateAction<boolean>>;
  removeFile: () => void;
}) {
  return (
    <MyModal
      show={removeFileModalShow}
      title={'Remover / cancelar arquivo'}
      closeButtonLabel="Fechar"
      actionButtonLabel={'Confirmar'}
      onClose={() => setRemoveFileModalShow(false)}
      onAction={() => removeFile()}
      type="deleteAction"
      modalBody={(
        <>
              Tem certeza que deseja remover este arquivo?
        </>
      )}
    />
  );
}
